export function getOffset<Value>(
  value?: Value[],
  defaultValue?: Value[],
): number {
  return value?.length ?? defaultValue?.length ?? 0;
}
